import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  trafficStatus: [],
  loadingTrafficStatus: false,
  trafficStatusV2: [],
  loadingTrafficStatusV2: false,
  trafficStatusRectangle: [],
  loadingTrafficRectangle: false,
  trafficStatusCircle: [],
  loadingTrafficCircle: false,
};

const trafficStatusMapSlice = createSlice({
  name: 'trafficStatusMap',
  initialState,
  reducers: {
    getTrafficStatusForMap: () => {},
    saveTrafficStatusForMap: (state, { payload }) => {
      state.trafficStatus = payload;
      state.loadingTrafficStatus = false;
    },
    changeLoading: (state, { payload }) => {
      state.loadingTrafficStatus = payload;
    },
    getTrafficStatusForMapV2: () => {},
    saveTrafficStatusForMapV2: (state, { payload }) => {
      state.trafficStatusV2 = payload;
      state.loadingTrafficStatusV2 = false;
    },
    changeLoadingV2: (state, { payload }) => {
      state.loadingTrafficStatusV2 = payload;
    },
    getTrafficStatusRectangle: () => {},
    saveTrafficStatusRectangle: (state, { payload }) => {
      state.trafficStatusRectangle = payload;
      state.loadingTrafficRectangle = false;
    },
    changeLoadingRectangle: (state, { payload }) => {
      state.loadingTrafficRectangle = payload;
    },
    getTrafficStatusCircle: () => {},
    saveTrafficStatusCircle: (state, { payload }) => {
      state.trafficStatusCircle = payload;
      state.loadingTrafficCircle = false;
    },
    changeLoadingCircle: (state, { payload }) => {
      state.loadingTrafficCircle = payload;
    },
  },
});

export const {
  getTrafficStatusForMap,
  saveTrafficStatusForMap,
  changeLoading,
  getTrafficStatusForMapV2,
  saveTrafficStatusForMapV2,
  changeLoadingV2,
  getTrafficStatusRectangle,
  saveTrafficStatusRectangle,
  changeLoadingRectangle,
  getTrafficStatusCircle,
  saveTrafficStatusCircle,
  changeLoadingCircle,
} = trafficStatusMapSlice.actions;

export default trafficStatusMapSlice.reducer;
